<template>
  <div
    class="d-flex justify-content-between align-items-center custom-border-bottom custom-padding-x"
  >
    <div
      :class="[textVariant, { 'custom-hover-pointer': isEnableHoverEffect }]"
      @click="clickItem()"
    >
      <span class="font-weight-500">{{ item }}</span>
      <feather-icon
        v-if="showLinkIcon"
        icon="Link2Icon"
        size="14"
        class="custom-margin-left-8"
      />
    </div>
    <div
      v-if="isEnableDeleteItem"
      class="custom-hover-pointer"
      @click="clickDeleteItem()"
    >
      <feather-icon icon="Trash2Icon" size="14" class="custom-margin-left-8" />
    </div>
  </div>
</template>

<script>
export default {
  name: "AtomItemList",
  props: {
    item: {
      type: String,
      required: true,
    },
    textVariant: {
      type: String,
      required: false,
      default: "text-color-black",
      validator: (value) => {
        return [
          "text-color-primary",
          "text-color-black",
          "text-color-grey",
          "text-color-danger",
          "text-color-warning",
          "text-color-success",
          "text-color-info",
        ].includes(value)
      },
    },
    showLinkIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    isEnableDeleteItem: {
      type: Boolean,
      required: false,
      default: true,
    },
    isEnableHoverEffect: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  emits: ["onClickItem", "onClickDeleteIcon"],

  methods: {
    clickItem() {
      this.$emit("onClickItem", this.item)
    },

    clickDeleteItem() {
      this.$emit("onClickDeleteIcon", this.item)
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-hover-pointer:hover {
  cursor: pointer;
}

.custom-border-bottom {
  border-bottom: 1px solid #ebe9f1;
}

.custom-padding-left-8 {
  padding-left: 8px;
}

.custom-margin-left-8 {
  margin-left: 8px;
}

.custom-padding-x {
  padding: 8px 0;
}
</style>
